import { COLUMNS } from './keys';
import { query } from './query';
import DataTable from '../../../../components/Datatable';
import Component from '../../../../components/Component';
import { noDataMessage } from '../../../../helpers/noDataMessage';
import Loading from '../../../../components/Loading';
import { scrollForTable } from '../../../../components/Datatable/utils';
import { withTranslation } from 'react-i18next';

class OverallPerformance extends Component {
    constructor(props) {
        super();
        if (!props.data) this.query = query(props.dates);
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.dates) !== JSON.stringify(this.props.dates)) {
            this.props.updateDates({ key: 'overallPerformance', value: null });
            this.setState({ loading: true, data: null });
            this.query = query(this.props.dates);
            this.query.bind(this.setState.bind(this));
            this.query.update();
            this.props.updateDates({ emptyAll: true });
        }
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDates({ key: 'overallPerformance', value: this.state.data });
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.device?.toLowerCase().includes(search.toLowerCase()));
    }

    render() {
        const { t } = this.props;

        const data = this.state.data?.length ? this.state.data : this.props.data;
        if ((!data || !data.length) && this.state.loading && !this.props.data)
            return <Loading padding={10} />;

        const total = data?.reduce(
            (acc, curr) => {
                acc = {
                    device: 'TOTAL',
                    clicks: acc.clicks + curr.clicks,
                    clicksPrior: acc.clicksPrior + curr.clicksPrior,
                    impressions: acc.impressions + curr.impressions,
                    impressionsPrior: acc.impressionsPrior + curr.impressionsPrior,
                    avgCTR: acc.avgCTR + curr.avgCTR,
                    avgCTRPrior: acc.avgCTRPrior + curr.avgCTRPrior,
                    avgPosition: acc.avgPosition + curr.avgPosition,
                    avgPositionPrior: acc.avgPositionPrior + curr.avgPositionPrior,
                };

                return acc;
            },
            {
                device: '',
                clicks: 0,
                clicksPrior: 0,
                impressions: 0,
                impressionsPrior: 0,
                avgCTR: 0,
                avgCTRPrior: 0,
                avgPosition: 0,
                avgPositionPrior: 0,
            },
        );

        const sortFns = {
            device: (array) => array.sort((a, b) => a.device.localeCompare(b.device)),
            impressions: (array) =>
                array.sort((a, b) => {
                    return a.impressions - b.impressions;
                }),
            impressions_delta: (array) =>
                array.sort((a, b) => {
                    const aValue = a.impressions - (a.impressionsPrior || 0);
                    const bValue = b.impressions - (b.impressionsPrior || 0);
                    return aValue - bValue;
                }),
            clicks: (array) =>
                array.sort((a, b) => {
                    return a.clicks - b.clicks;
                }),
            clicks_delta: (array) =>
                array.sort((a, b) => {
                    const aValue = a.clicks - (a.clicksPrior || 0);
                    const bValue = b.clicks - (b.clicksPrior || 0);
                    return aValue - bValue;
                }),
            avgPosition: (array) =>
                array.sort((a, b) => {
                    return a.avgPosition - b.avgPosition;
                }),
            avgPosition_delta: (array) =>
                array.sort((a, b) => {
                    const aValue = a.avgPosition - (a.avgPositionPrior || 0);
                    const bValue = b.avgPosition - (b.avgPositionPrior || 0);
                    return aValue - bValue;
                }),
            avgCTR: (array) =>
                array.sort((a, b) => {
                    return a.clicks / (a.impressions || 1) - b.clicks / (b.impressions || 1);
                }),
            avgCTR_delta: (array) =>
                array.sort((a, b) => {
                    const aValue = a.avgCTR - (a.avgCTRPrior || 0);
                    const bValue = b.avgPosition - (b.avgCTRPrior || 0);
                    return aValue - bValue;
                }),
        };

        return !data || !data.length ? (
            <div>{noDataMessage}</div>
        ) : (
            <DataTable
                nodes={[total, ...data]}
                sortFns={sortFns}
                COLUMNS={COLUMNS(t)}
                uniqKey={'device'}
                fileName={t('search.comparison.overallPerformance.header')}
                header={t('search.comparison.overallPerformance.header')}
                searchFunction={this.searchFunction}
                onlyTable
                forceRun={this.forceRun}
                additionalStyles={{
                    Table: `
                                --data-table-library_grid-template-columns : minmax(120px, 2fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) minmax(120px, 1fr) minmax(180px, 1.8fr) !important;
                               ${scrollForTable}
                            `,
                    BaseCell: ` font-family: 'Raleway';
                                font-weight: 500;
                                font-size: 16px;
                                line-height: 19px;
                                padding: 16px 10px;
                                color: #0D182C;
                            
                            
                                &.underline {
                                text-decoration: underline;
                                }`,
                }}
            />
        );
    }
}

export default withTranslation()(OverallPerformance);
